import { WorkflowElement } from "../element"
import { UnstartedSubscriber } from "./unstarted-subscribers"

export class AsyncStats extends WorkflowElement {
  static get elementName() {
    return "workflow-async-stats"
  }
  static get observedAttributes() {
    return ["data-type-id", "data-type"]
  }

  // oxlint-disable-next-line constructor-super -- super() is called via `const self = super(disabled)`
  constructor(disabled) {
    const self = super(disabled)
    self.tmpAttributes = {}
    for (let i = 0; i < self.attributes.length; i++) {
      let attrib = self.attributes[i]
      self.tmpAttributes[attrib.name] = attrib.value
      self.removeAttribute(attrib.name)
    }
  }

  initialize(disabled) {
    this.fetched = false
    if (!disabled) {
      this.onclick = this.viewSubscribers
    }
  }

  viewSubscribers(event) {
    event.stopPropagation()

    const workflowNode = this.parentNode.parentNode
    const workflowGraph = workflowNode.parentNode
    const statsElement = event.target.closest("[data-stat]")

    if (!statsElement) {
      return
    }

    if (statsElement.dataset.stat == "held") {
      return
    } else if (statsElement.dataset.stat == "current") {
      window.location.href = `/automations/${workflowGraph.dataset.oid}/nodes/${workflowNode.dataset.oid}/subscribers/current`
    } else if (statsElement.dataset.stat == "finished") {
      window.location.href = `/automations/${workflowGraph.dataset.oid}/nodes/${workflowNode.dataset.oid}/subscribers/completed`
    }
  }

  connectedCallback() {
    // Safari. Is. IE 6
    for (let key in this.tmpAttributes) {
      this.setAttribute(key, this.tmpAttributes[key])
    }

    this.fetchStats = this.fetchStats.bind(this)
    this.handleResponse = this.handleResponse.bind(this)
    this.replaceStats = this.replaceStats.bind(this)
    this.replaceCurrent = this.replaceCurrent.bind(this)
    this.replaceFinished = this.replaceFinished.bind(this)
    this.fetchStatsFail = this.fetchStatsFail.bind(this)

    if (!this.fetched && this.dataset.typeId && this.dataset.type) {
      this.fetchStats()
    }
  }

  attributeChangedCallback(attributeName) {
    if (
      attributeName == "data-type-id" ||
      attributeName == "data-type" ||
      attributeName == "data-updated-at"
    ) {
      if (
        !this.fetched &&
        this.dataset.typeId &&
        this.dataset.type &&
        this.dataset.updatedAt
      ) {
        this.fetchStats()
      }
    }
  }

  fetchStats() {
    const statsRoute = `/workflows/steps/${this.dataset.typeId}/stats.json?step_type=${this.dataset.type}&cache_tag=${this.dataset.updatedAt}`

    fetch(statsRoute, { credentials: "include" })
      .then(this.handleResponse)
      .then(this.replaceStats)
      .catch(this.fetchStatsFail)
  }

  handleResponse(response) {
    if (response.status === 200) {
      return response.json()
    } else {
      throw new Error("Error loading stats")
    }
  }

  replaceStats(stats) {
    this.replaceCurrent(stats)
    this.replaceFinished(stats)
    this.replaceHeld(stats)
    this.replaceWaiting(stats)
    this.fetched = true
  }

  replaceCurrent(stats) {
    const currentStat = this.find("[data-stat='current']")
    const count = currentStat.querySelector(".js-count")
    const label = currentStat.querySelector(".js-label")

    if (stats.paused_subscriber_count > 0) {
      count.innerText = `${stats.paused_subscriber_count} Subscribers`
      label.innerText = "Paused"
    } else {
      count.innerText = `${stats.current_subscriber_count} Subscribers`
    }

    count.classList.remove("placeholder")
  }

  replaceFinished(stats) {
    const finishedStat = this.find("[data-stat='finished']")
    const count = finishedStat.querySelector(".js-count")

    count.innerText = `${stats.finished_subscriber_count} Subscribers`
    count.classList.remove("placeholder")
  }

  replaceHeld(stats) {
    const currentStat = this.find("[data-stat='held']")
    const count = currentStat.querySelector(".js-count")

    if (!stats.held_subscriber_count) {
      currentStat.classList.add("hidden")
    } else if (stats.held_subscriber_count === 1) {
      count.innerText = `${stats.held_subscriber_count} Subscriber on hold`
      currentStat.classList.remove("hidden")
    } else {
      count.innerText = `${stats.held_subscriber_count} Subscribers on hold`
      currentStat.classList.remove("hidden")
    }
  }

  replaceWaiting(stats) {
    const workflowNode = this.parentNode.parentNode
    const unstartedElements = workflowNode.querySelectorAll(
      "workflow-unstarted-subscribers"
    )

    if (unstartedElements) {
      unstartedElements.forEach(e => e.remove())
    }

    if (stats.waiting_subscriber_count > 0) {
      const box = new UnstartedSubscriber()
      box.dataset.unstarted_count = stats.waiting_subscriber_count
      box.dataset.live = stats.live
      box.onclick = this.viewWaitingSubscribers

      workflowNode.appendChild(box)
      workflowNode.classList.add("has-waiting")

      Workflow.waitingNodeIds.push(parseInt(workflowNode.dataset.oid))
      Workflow.dataset.nodesWaiting = true // triggers graph.attributeChangedCallback()
    }
  }

  viewWaitingSubscribers() {
    const workflowNode = this.parentNode
    const workflowGraph = workflowNode.parentNode
    window.location.href = `/automations/${workflowGraph.dataset.oid}/nodes/${workflowNode.dataset.oid}/subscribers/waiting`
  }

  fetchStatsFail(error) {
    console.warn("Error Loading Async Stats", error.message)
    this.innerText = "Error loading stats"
  }
}

customElements.get(AsyncStats.elementName) ||
  customElements.define(AsyncStats.elementName, AsyncStats)
